function MdxPatientDataVO(firstName, lastName, email, phoneNumber, nin) {

    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.nin = nin;

    var _typeContext = {
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}

MdxPatientDataVO.prototype.getFullName = function () {
    var fullName = '';
    if(this.firstName) {
        fullName += this.firstName;
    }
    if(this.lastName) {
        if(fullName) {
            fullName += ' ';
        }
        fullName += this.lastName;
    }
    return fullName;
};
